<template>
  <section class="fill-height">
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title v-if="study_group" class="unselectable">
        {{ study_group.name }} <br>
        <small>
          {{ $moment(study_group.start_at).format('DD MMMM YYYY') }} -
          {{ $moment(study_group.end_at).format('DD MMMM YYYY') }}
        </small>
      </v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>
        <v-tabs centered class="blur">
          <v-tab :to="{name: 'Study group main', params: $route.params}">Main</v-tab>
          <!--          <v-tab :to="{name: 'Study group chat', params: $route.params}">Chat</v-tab>-->
          <v-tab v-if="authUserCourseLeader" :to="{name: 'Edit study group', params: $route.params}">Edit</v-tab>
          <v-tab v-if="authUserCourseLeader || authUserAdmin" :to="{name: 'Edit study members', params: $route.params}">Members</v-tab>
          <v-tab v-if="authUserCourseLeader" :to="{name: 'Study subgroups', params: $route.params}">Sub groups</v-tab>
          <v-tab v-if="authUserCourseLeader" :to="{name: 'Study group schedule', params: $route.params}">Schedule</v-tab>
          <v-tab v-if="authUserCourseLeader" class="error" @click="delete_stg_dialog =!delete_stg_dialog">Delete</v-tab>

          <template v-if="profile_type && profile_type === 'aspiringSolicitor'">
            <v-tab v-if="can_join" :to="{name: 'Study group join', params: $route.params}">Join</v-tab>
<!--            <v-tab :to="{name: 'Study group booking policy', params: $route.params}">Booking policy</v-tab>-->
          </template>
          <template v-else>

          </template>
        </v-tabs>
      </template>
    </v-toolbar>

    <router-view :study_group="study_group" @loadStudyGroup="loadStudyGroup"/>

    <v-dialog v-model="delete_stg_dialog" max-width="500px">
      <v-alert prominent type="error" class="mb-0">
        <v-row align="center">
          <v-col class="grow">
            Do you want to delete this group?
          </v-col>
          <v-col class="shrink">
            <v-btn @click="deleteStudyGroup">Delete</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-dialog>
  </section>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  data: () => ({
    study_group: null,
    members: [],
    api_errors: [],
    delete_stg_dialog: false,
  }),
  computed: {
    ...mapGetters({
      profile_type: 'getAuthUserProfileType',
      profile_type_label: 'getAuthUserProfileTypeLabel',
      authUserStudyGroups: 'getAuthUserStudyGroups',
    }),
    user_study_group: function () {
      if(this.study_group) {
        return this.authUserStudyGroups.find(user_study_group => user_study_group.study_group_id === this.study_group.id)
      }
      return null
    },
    can_join: function () {
      if(this.study_group && !this.user_study_group) {
        let open = this.$moment(this.study_group.recruitment_start)
        let close = this.$moment(this.study_group.recruitment_end)
        return this.$currentTime().isBetween(open, close)
      }
      return false
    },
  },
  mounted() {
    this.loadStudyGroup()
  },
  methods: {
    async loadStudyGroup() {
      this.study_group = await this.axios.get(`api/study-groups/${this.$route.params.study_group_id}`)
          .then(({data}) => data.data)
    },
    deleteStudyGroup() {
      this.axios.delete(`api/study-groups/${this.$route.params.study_group_id}`)
        .then(() => {
          this.$router.push({name: 'Study groups'})
        })
    }
  }
}
</script>